import { Component } from '@verndale/core';
import DesktopGlobalNavigation from './DesktopGlobalNavigation';
import MobileGlobalNavigation from './MobileGlobalNavigation';
import { debounce } from '../../../helpers';
import { breakpoints } from '../../../helpers/variables';
import CustomHeader from './CustomHeader';

class GlobalNavigation extends Component {
  desktopGlobalNavigation: DesktopGlobalNavigation | null = null;
  mobileGlobalNavigation: MobileGlobalNavigation | null = null;
  customHeader: CustomHeader | null = null;
  isDesktop = false;

  constructor(el: HTMLElement) {
    super(el);
    const header = document.querySelector('.header') as HTMLElement;
    header.style.display = 'block';

    this.isDesktop = window.matchMedia(
      `(min-width: ${breakpoints.tabletLandscape}px)`
    ).matches;
    this.initNavigation();
  }

  setupDefaults() {
    this.dom = {
      el: this.el
    };
  }

  addListeners() {
    window.addEventListener(
      'resize',
      debounce(this.checkViewportWidth.bind(this), 300)
    );
  }

  checkViewportWidth() {
    if (
      this.isDesktop &&
      !window.matchMedia(`(min-width: ${breakpoints.tabletLandscape}px)`)
        .matches
    ) {
      this.isDesktop = false;
      this.initNavigation();
    } else if (
      !this.isDesktop &&
      window.matchMedia(`(min-width: ${breakpoints.tabletLandscape}px)`).matches
    ) {
      this.isDesktop = true;
      this.initNavigation();
    }
  }
  initNavigation() {
    if (this.isDesktop) {
      if (this.mobileGlobalNavigation !== null) {
        this.mobileGlobalNavigation.removeListeners();
        this.mobileGlobalNavigation.resetMenu();
      }
      this.desktopGlobalNavigation = new DesktopGlobalNavigation(
        this.dom.el as HTMLElement
      );
      this.customHeader = new CustomHeader(
        this.dom.el as HTMLElement
      );
    } else {
      if (this.desktopGlobalNavigation !== null) {
        this.desktopGlobalNavigation.removeListeners();
        this.desktopGlobalNavigation.hideMenu();
      }
      this.mobileGlobalNavigation = new MobileGlobalNavigation(
        this.dom.el as HTMLElement
      );
    }
  }
}

export default GlobalNavigation;
